import React from 'react';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import compose from '@shopify/react-compose';
import i18nArgs from '../locales';
import {RouteComponentProps} from 'react-router-dom';
import {getServicesMarketplacePublicClient} from 'utilities/graphql/client';
import GetProfileQuery, {
  GetProfileQueryData,
} from '../graphql/GetProfileQuery.graphql';
import {notifyException} from 'utilities/analytics/bugsnag';
import {ProfileListingSkeleton} from './ProfileListingSkeleton';
import Profile from './Profile';
import NotFound from '../../not-found';
import {producePageViewMonorailEvent} from 'sections/services-marketplace/experts/utilities/monorail';
import {toHandle} from 'sections/services-marketplace/experts/utilities';
import {MonorailPageIndicators} from 'sections/services-marketplace/experts/utilities/constants';

const client = getServicesMarketplacePublicClient();

interface OwnProps {}

interface State {
  profile?: GetProfileQueryData.Profile;
}

type CombinedProps = OwnProps &
  RouteComponentProps<{
    expertSlug: string;
    serviceSlug: string;
  }> &
  WithI18nProps;

class ProfileListing extends React.Component<CombinedProps, State> {
  state: State = {
    profile: undefined,
  };

  componentDidMount() {
    this.fetchProfile();
  }

  componentDidUpdate(prevProps: CombinedProps) {
    if (
      this.props.match.params.serviceSlug !== prevProps.match.params.serviceSlug
    ) {
      this.fetchProfile();
    }

    const serviceHandle = toHandle(this.props.match.params.serviceSlug);

    producePageViewMonorailEvent({
      pageIndicator: MonorailPageIndicators.profileListing,
      serviceHandle,
    });
  }

  fetchProfile() {
    client
      .query<{
        profile: GetProfileQueryData.Profile;
      }>({
        query: GetProfileQuery,
        variables: {
          serviceHandle: this.props.match.params.serviceSlug,
          handle: this.props.match.params.expertSlug,
        },
      })
      .then(res => {
        this.setState({profile: res.data.profile});
      })
      .catch(error => {
        notifyException({error});
      });
  }

  render() {
    const {profile} = this.state;

    if (profile === undefined) return <ProfileListingSkeleton />;

    if (profile === null) return <NotFound />;

    return <Profile profile={profile} />;
  }
}

export default compose<OwnProps>(withI18n(i18nArgs))(ProfileListing);
